<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/systemVisits'"
      style="border: 0"
      class="mt-0 mb-0 pa-5"
    >
      <h3 class="grey--text text--darken-2">
        <v-icon class="primary--text">mdi-chart-bell-curve-cumulative</v-icon>
        گزارش‌های بازدید از سامانه
      </h3>
      <hr class="my-6" />
      <h5 class="c-grey">
        مدیر گرامی، در این بخش می توانید گزارش‌های مربوط به بازدید نقش‌های مختلف
        از سامانه را در بازه زمانی مورد نظر مشاهده فرمایید.
      </h5>
      <hr class="my-6" />

      <v-row class="mb-4">
        <v-col>
          <label class="font-weight-bold">از تاریخ:</label>
          <date-picker
            v-model="startDate"
            type="date"
            :auto-submit="true"
            color="#068d9d"
          >
          </date-picker
        ></v-col>
        <v-col>
          <label class="font-weight-bold">تا تاریخ:</label>
          <date-picker
            v-model="endDate"
            type="date"
            :auto-submit="true"
            color="#068d9d"
            :max="currentDate"
          >
          </date-picker
        ></v-col>
      </v-row>
      <v-row>
        <v-col class="text-end pt-0">
          <v-btn
            class="bc-primary text-white no-underline pa-5 btn-radius"
            elevation="0"
            @click="getChartsInfo()"
          >
            <v-icon class="me-1">mdi-check</v-icon>
            اعمال</v-btn
          >
        </v-col>
      </v-row>
      <hr />
      <div class="text-center" v-if="lineBusy">
        <b-spinner variant="primary" type="grow"></b-spinner>
      </div>
      <div v-else class="container animated fadeIn">
        <div v-if="showChart">
          <v-expansion-panels>
            <v-expansion-panel v-for="(item, index) in userList" :key="index">
              <v-expansion-panel-header @click="loadChart()"
                ><h5 class="my-4">
                  نمودار {{ item.faName }}
                </h5></v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <div class="pa-8">
                  <div
                    v-if="chartLoading"
                    class="d-flex flex-column align-center justify-content-center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      :size="40"
                    ></v-progress-circular>
                    <h5 class="mt-4 primary--text">در حال بارگذاری...</h5>
                  </div>
                  <div v-else>
                    <span v-show="false">{{ reactivity }}</span>
                    <v-btn
                      class="bc-primary text-white btn-radius mb-8"
                      width="200"
                      height="47"
                      elevation="0"
                      @click="
                        capture(
                          `capture${index}`,
                          `نمودار  ${item.faName} از تاریخ ${startDate} تا تاریخ ${endDate}`,
                          0
                        )
                      "
                      data-html2canvas-ignore
                      :loading="gettingPic[0]"
                    >
                      <template v-slot:loader>
                        <span class="white--text fs-xsmall d-flex flex-row">
                          <span
                            ><v-icon class="white--text"
                              >mdi-timer-sand-empty</v-icon
                            >
                            چند لحظه صبر کنید...
                          </span>
                        </span>
                      </template>
                      <span class="fs-small">
                        <v-icon class="me-1">$Camera</v-icon>
                        خروجی عکس
                      </span>
                    </v-btn>
                    <a id="download"></a>
                    <div :id="`capture${index}`" class="pa-5">
                      <h5 class="primary--text mb-2">
                        {{
                          `نمودار بازدید از سامانه توسط ${item.faName} از تاریخ ${startDate} تا تاریخ ${endDate}:`
                        }}
                      </h5>
                      <Chart
                        :name="`lineChart${index + 1}`"
                        type="line"
                        :chartdata="users[item.engName].visits"
                        :options="optionsLine"
                        height="160"
                      >
                      </Chart>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import screenShot from "../../mixins/screenShot";
export default {
  components: { Chart, datePicker: VuePersianDatetimePicker },
  mixins: [screenShot],
  data() {
    return {
      moment: moment,
      showChart: false,
      optionsLine: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "top",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 25,
              boxHeight: 8,
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            min: 0,
            title: {
              display: true,
              text: "تعداد کاربر بازدید کننده",
              font: { family: "iransans" },
            },
            grid: {
              display: false,
            },
            ticks: {
              stepSize: 10,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      lineBusy: false,
      startDate: moment(new Date())
        .subtract(1, "month")
        .format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      userList: [
        {
          faName: "پژوهشگران",
          engName: "researchers",
        },
        {
          faName: "دانشگاه‌ها",
          engName: "universities",
        },
        {
          faName: "داوران",
          engName: "referees",
        },
        {
          faName: "شرکت‌ها",
          engName: "companies",
        },
        {
          faName: "شتاب‌دهنده‌ها",
          engName: "accelerators",
        },
      ],
      users: [],
      chartLoading: false,
      reactivity: false,
    };
  },

  methods: {
    getChartsInfo() {
      this.lineBusy = true;
      this.$http
        .get(
          this.baseUrl +
            `/setad/admin/reports/activities/views?start=${this.startDate}&end=${this.endDate}`,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.users = res.data;
            setTimeout(() => {
              this.showChart = true;
              this.lineBusy = false;
            }, 100);
          } else {
            this.toast(res.data, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    loadChart() {
      this.chartLoading = true;
      setTimeout(() => {
        this.chartLoading = false;
      }, 300);
    },
  },
  updated() {},
  mounted() {
    this.role = localStorage.getItem("role");
    this.gettingPic[0] = false;
    this.getChartsInfo();
  },
};
</script>

